import { DataTable, DataTableData } from "@/src/components/ui/data-table";
import { useEffect, useState } from "react";
import { Town } from "./model";
import { useSearch, usePageSize } from "./state";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/src/lib/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import { extractFromMultiName } from "./utils";

export function TownsTable() {
  const [towns, setTowns] = useState<DataTableData<Town>>({
    data: [],
    total: 1,
    pagination: { page: 1, pageSize: 1 },
  });
  const [page, setPage] = useState(1);

  const navigate = useNavigate();
  const search = useSearch();
  const pageSize = usePageSize();
  const { fetch } = useFetch();

  useEffect(() => {
    const fetchTowns = (page: number) =>
      fetch<DataTableData<Town>>(`/api/locations/towns?page=${page}&pageSize=${pageSize}&filter=${search}`);

    fetchTowns(page).then((data) => {
      setTowns(data);
    });
  }, [page, search, pageSize]);

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-md bg-white border">
        <DataTable
          columns={townsColumns}
          pagination={towns}
          data={towns.data}
          onPageClick={setPage}
          onRowClick={(r) => navigate(`/locations/towns/${r.id}`)}
        />
      </div>
    </div>
  );
}

export const townsColumns: ColumnDef<Town>[] = [
  {
    header: "Name",
    accessorFn: (t) => extractFromMultiName(t.names),
  },
  {
    header: "Country",
    accessorFn: (t) => extractFromMultiName(t.country.names),
  },
];
